<template>
  <span ref="trigger" />
</template>
<script>
export default {
  props: {
    options: {
      type: Object,
      default: () => ({
        root: null,
        threshold: '0', // 0 meaning as soon as even one pixel is visible and 1 meaning the whole element must be visible
      }),
    },
  },
  data() {
    return {
      observer: {},
    };
  },
  mounted() {
    this.observer = new IntersectionObserver((entries) => {
      this.handleIntersect(entries[0]);
    }, this.options);
    this.observer.observe(this.$refs.trigger);
  },
  destroyed() {
    this.observer.disconnect();
  },
  methods: {
    handleIntersect(entry) {
      if (entry.isIntersecting) this.$emit('refresh');
    },
  },
};
</script>
